/**************************************************
 * Nombre:       Pdf_Recibo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Document, Font, Image, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import f500 from './Recursos/Poppins-Regular.ttf'
import f600 from './Recursos/Poppins-Medium.ttf'
import f700 from './Recursos/Poppins-Bold.ttf'
import cabecera from './Recursos/cabecera.png'
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";


const Pdf_Recibo = ({item, antesDe}) => {
    Font.register({family: '500', src: f500})
    Font.register({family: '600', src: f600})
    Font.register({family: '700', src: f700})


    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#FFF',
            padding: 0,
        },
        columna: {
            justifyContent: 'flex-start',
            flexDirection: 'column',
            width: '100%',
            paddingTop: 20
        },
        gitc: {
            justifyContent: 'center',
            flexDirection: 'row',
            width: '100%'
        },
        git: {
            justifyContent: 'flex-start',
            flexDirection: 'row',
            width: '100%'
        },
        gitg: {
            justifyContent: 'flex-end',
            flexDirection: 'row',
            width: '100%'
        },
        texto: {
            fontSize: 10,
            fontFamily: '600'
        },
        textoL: {
            fontSize: 14,
            fontFamily: '500',
        },
        textoGT: {
            fontSize: 14,
            fontFamily: '700',
            lineHeight: 1.1
        },
        textoG: {
            fontSize: 38,
            fontFamily: '700',
            lineHeight: 1.1
        },


    });

    const TituloTexto = ({titulo, texto}) => {

        return (
            <View style={{...styles.git, marginLeft: 30, marginRight: 30}}>

                <View style={{...styles.git, width: '40%'}}>
                    <Text style={styles.textoGT}>{titulo + ': '}</Text>
                </View>

                <View style={{...styles.git, width: '60%'}}>
                    <Text style={styles.textoL}>{texto}</Text>
                </View>

            </View>
        )
    }


    return (
        <Document>
            <Page size={[500, 750]} style={styles.page}>

                <View style={styles.git}>


                    <View style={styles.columna}>

                        <View style={{...styles.gitc, marginTop: 0}}>
                            <Image src={cabecera} style={{width: 440, height: 'auto'}}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10, borderTop: 10, marginRight: 30, marginLeft: 30}}>
                            <Text
                                style={styles.textoL}>-------------------------------------------------------</Text>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Consecutivo'} texto={item.consecutivo}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Consignar antes de'} texto={antesDe}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Titular de la cuenta'} texto={'ESPERANZA HISPANA SAS'}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Nit'} texto={'901933776'}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10, borderTop: 10, marginRight: 30, marginLeft: 30}}>
                            <Text
                                style={styles.textoL}>-------------------------------------------------------</Text>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Tipo de cuenta'} texto={'Cuenta de Ahorros'}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Numero Cuenta'} texto={'88800005238'}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Valor a depositar'} texto={formatoMoneda(item.valor)}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10, borderTop: 10, marginRight: 30, marginLeft: 30}}>
                            <Text
                                style={styles.textoL}>-------------------------------------------------------</Text>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Nombre depositante:'} texto={item.nombres + ' ' + item.apellidos}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10}}>
                            <TituloTexto titulo={'Cc'} texto={item.cc}/>
                        </View>

                        <View style={{...styles.git, marginTop: 10, marginRight: 30, marginLeft: 30}}>
                            <Text style={styles.texto}>{item.idUsuario}</Text>
                        </View>

                    </View>
                </View>


            </Page>
        </Document>
    )

}
export default Pdf_Recibo